// Arabic / English text of the unified Requests page.
// Request data labels (statuses, kinds, categories) come from the API in both
// languages; only interface wording lives here.

const ar = {
  sections: { inProgress: "قيد التنفيذ", completed: "المكتملة" },
  emptySection: { inProgress: "لا توجد طلبات قيد التنفيذ.", completed: "لا توجد طلبات مكتملة." },
  countLabel: (n) => `${n} طلب`,
  quickActions: "إجراءات سريعة",
  expand: { expand: "اضغط لعرض النص كاملاً", collapse: "اضغط لطيّ النص" },
  title: "الطلبات",
  details: "التفاصيل",
  openDetails: "عرض تفاصيل الطلب",
  loading: "جاري تحميل الطلبات…",
  errorTitle: "تعذّر تحميل الطلبات",
  retry: "إعادة المحاولة",
  forbidden: "ليس لديك صلاحية للاطلاع على هذا المطعم.",
  network: "تعذّر الاتصال بالخادم.",
  pagination: { nav: "التنقل بين الصفحات", previous: "السابق", next: "التالي", limit: "تم الوصول إلى أقصى عمق للتصفح؛ استخدم الفلاتر لتضييق النتائج.", summary: (page, pages, total) => `صفحة ${page}${pages ? ` من ${pages}` : ""}${total !== null && total !== undefined ? ` · ${total} طلب` : ""}` },
  noValue: "—",
  hidden: "مخفي",
  modal: {
    close: "إغلاق",
    moreInfo: "معلومات إضافية",
    info: "معلومات الطلب",
    scope: "النطاق",
    status: "الحالة",
    original: "الحالة الأصلية",
    reference: "المرجع",
    type: "النوع",
    category: "التصنيف",
    store: "المطعم",
    branch: "الفرع",
    app: "التطبيق",
    creator: "المنشئ",
    created: "تاريخ الإنشاء",
    updated: "آخر تحديث",
    summary: "الملخص",
    changes: "التغييرات المطلوبة",
    current: "الحالي",
    requested: "المطلوب",
    approvals: "الموافقات",
    history: "السجل",
    historyEmpty: "لا يوجد سجل لهذا الطلب.",
    attachments: "المرفقات",
    actions: "الإجراءات",
    noActions: "لا توجد إجراءات متاحة لك على هذا الطلب.",
    openOriginal: "فتح الصفحة الأصلية",
    loadError: "تعذّر تحميل تفاصيل الطلب.",
    notFound: "الطلب غير موجود أو لا تملك صلاحية الاطلاع عليه.",
    onBehalf: "اعتُمد نيابةً عن العميل",
    clientApproval: "موافقة العميل",
    managerApproval: "موافقة مدير LUD",
    waiting: "بانتظار القرار",
    approved: "موافق",
    rejected: "مرفوض",
    reason: "السبب",
    note: "ملاحظة",
  },
  action: {
    approveClient: "موافقة العميل",
    rejectClient: "رفض",
    approveManager: "موافقة المدير",
    rejectManager: "رفض",
    onBehalf: "اعتماد نيابةً عن العميل",
    activate: "تفعيل",
    completed: "تحديد كمكتمل",
    rejected: "رفض",
    inprogress: "قيد التنفيذ",
    cancelCampaign: "إلغاء الحملة",
    deleteRequest: "حذف الطلب",
    edit: "تعديل في صفحة العمليات",
    approve: "موافقة",
    reject: "رفض",
    cancel: "إلغاء الطلب",
    upload: "رفع ملف",
    send: "إرسال",
    retry: "إعادة الإرسال",
    complete: "تحديد كمكتمل",
    editApp: "تعديل في صفحة التطبيقات",
    chooseFile: "اختر ملفاً",
    fileKind: "نوع الملف",
    confirm: "تأكيد",
    more: "المزيد من الإجراءات",
    cancelDialog: "تراجع",
    reasonLabel: "السبب",
    reasonRequired: "السبب مطلوب (3 أحرف على الأقل).",
    optionalNote: "ملاحظة (اختياري)",
    working: "جاري التنفيذ…",
    failed: "تعذّر تنفيذ الإجراء.",
    done: "تم تنفيذ الإجراء.",
    confirmOnBehalf: "أؤكد أن العميل وافق على هذا الطلب",
    onBehalfNote: "سيُسجَّل اعتمادك باسمك ودورك وسببك. تبقى موافقة مدير LUD المستقلة مطلوبة بعد ذلك من شخص آخر.",
    statusTitle: (label) => `تأكيد: ${label}`,
    confirmText: "هل أنت متأكد؟ سيُنفَّذ هذا الإجراء فوراً عبر مسار الطلب الأصلي.",
    uploadCompletes: "رفع هذا الملف يُنهي الطلب.",
    sendNote: "سيُرسل البريد التالي إلى التطبيق:",
    subject: "الموضوع",
    to: "إلى",
    cc: "نسخة",
    approveDashboard: "ستُطبَّق التغييرات المطلوبة على بيانات المطعم عند الموافقة.",
  },
  fields: {
    description: "الوصف",
    target: "الهدف",
    campaignName: "اسم الحملة",
    campaignDetails: "تفاصيل الحملة",
    startDate: "تاريخ البداية",
    endDate: "تاريخ النهاية",
    origin: "الأصل",
    source: "المصدر",
    reviewedBy: "راجعه",
    reviewedAt: "تاريخ المراجعة",
    reviewNote: "ملاحظة المراجعة",
    appliedAt: "تاريخ التطبيق",
    applyError: "آخر خطأ في التنفيذ",
    reason: "السبب",
    version: "الإصدار",
    scope: "النطاق",
    account: "الحساب المقترح",
    manager: "المدير المقترح",
    branches: "الفروع",
    passwordProvided: "كلمة المرور: مُدخلة (غير معروضة)",
    rejection: "سبب الرفض",
    language: "اللغة",
    sentAt: "تاريخ الإرسال",
    completedAt: "تاريخ الاكتمال",
    cancelledAt: "تاريخ الإلغاء",
    lastError: "آخر خطأ",
    attempts: "محاولات الإرسال",
    possiblyDelivered: "قد يكون البريد وصل (انقطع الإرسال)",
    day: { sunday: "الأحد", monday: "الاثنين", tuesday: "الثلاثاء", wednesday: "الأربعاء", thursday: "الخميس", friday: "الجمعة", saturday: "السبت" },
    closed: "مغلق",
    willChange: "سيتم تغييرها",
  },
  events: {
    created: "أُنشئ الطلب",
    alreadyActive: "أُدخل كحملة نشطة",
    approved: "تمت الموافقة",
    rejected: "تم الرفض",
    status: "تغيّرت الحالة",
    edited: "عُدّل الطلب",
    cancellationRequested: "أُلغيت الحملة",
    deleted: "حُذف الطلب",
    approvedOnBehalfOfClient: "اعتُمد نيابةً عن العميل",
    cancelled: "أُلغي الطلب",
    approval_failed: "فشل تطبيق الموافقة",
    send: "بدء الإرسال",
    accepted: "قبِل مزوّد البريد الرسالة",
    failed: "فشل الإرسال",
    recovered: "استُعيد بعد انقطاع",
    cancel: "أُلغي الطلب",
    complete: "اكتمل الطلب",
  },
  email: {
    section: "البريد الإلكتروني",
    history: "سجل الرسائل المرسلة",
    empty: "لا توجد رسائل بريد مرتبطة بهذا الطلب.",
    email: "رسالة",
    status: { sending: "جاري الإرسال", sent: "قُبلت لدى مزوّد البريد", failed: "فشل الإرسال", uncertain: "النتيجة غير معروفة", none: "لم تُرسل" },
    acceptedNote: "قبِل مزوّد البريد الرسالة. هذا لا يعني أنها وصلت أو قُرئت.",
    uncertainNote: "لا نعرف إن كانت الرسالة قد أُرسلت. لن تُعاد تلقائياً؛ يراجعها مسؤول من LUD.",
    attempts: "محاولات الإرسال",
    attempt: "المحاولة",
    result: { accepted: "قُبلت", failed: "فشلت", uncertain: "غير معروفة", sending: "جارية" },
    errorKind: { configuration: "إعدادات", validation: "بيانات غير صالحة", provider: "مزوّد البريد", network: "الشبكة", unknown: "غير معروف" },
    viewMessage: "عرض الرسالة",
    hideMessage: "إخفاء الرسالة",
    retry: "إعادة الإرسال",
    to: "إلى",
    cc: "نسخة",
    subject: "الموضوع",
    attachments: "المرفقات",
    body: "نص الرسالة",
    recipients: "التطبيقات المستلمة",
    missingTitle: "لا يمكن الإرسال: تطبيقات فعّالة بلا بريد اتصال صالح",
    missing: { RECIPIENT_NOT_CONFIGURED: "لم يُضبط بريد اتصال", RECIPIENT_INVALID: "بريد الاتصال المضبوط غير صالح", UNKNOWN_APPLICATION: "تطبيق غير معروف" },
    warnings: { STORE_EMAIL_INVALID: "بريد المطعم غير صالح؛ لن تُرسل له نسخة." },
    send: "معاينة وإرسال",
    dialogTitle: (label) => `معاينة وإرسال: ${label}`,
    previewing: "جاري تجهيز الرسالة…",
    previewError: "تعذّر تجهيز الرسالة.",
    reviewNote: "راجع الرسائل أدناه. لن يُرسل شيء قبل تأكيدك.",
    confirm: (count) => `راجعت الرسائل وأؤكد إرسالها إلى ${count} تطبيق`,
    sendNow: "إرسال",
    sendSelected: (count) => `إرسال (${count})`,
    selectTitle: "اختر التطبيقات التي ستُرسل لها الرسالة الآن",
    selectAll: "تحديد الكل",
    deselectAll: "إلغاء التحديد",
    selectOne: "اختر تطبيقاً واحداً على الأقل.",
    selectedCount: (count, total) => `المحدد: ${count} من ${total}. غير المحددة تبقى بانتظار الإرسال ويمكن إرسالها لاحقاً.`,
    confirmSelected: (names) => `راجعت الرسائل وأؤكد إرسالها إلى: ${names.join("، ")}`,
    alreadySent: "أُرسلت سابقاً - لن تُرسل مرة أخرى",
    missingPartial: "غير مشمولة الآن: تطبيقات بلا بريد اتصال صالح",
    willSend: "سيتم إرسالها",
    partialNote: "التطبيقات التي لا بريد اتصال لها تُتخطّى الآن وتبقى ظاهرة كناقصة ويمكن الإرسال لها لاحقاً.",
    sending: "جاري الإرسال…",
    sentTitle: "نتيجة الإرسال",
    allSent: "قبِل مزوّد البريد جميع الرسائل.",
    someNotSent: "لم تُقبل بعض الرسائل. يمكنك إعادة المحاولة للرسائل الفاشلة فقط.",
    draftChanged: "تغيّرت الرسالة منذ المعاينة. راجع النسخة الجديدة ثم أكّد من جديد.",
    close: "إغلاق",
    errors: {
      EMAIL_ACCESS_DENIED: "ليس لديك صلاحية إرسال هذه الرسالة.",
      RECIPIENTS_MISSING: "بعض التطبيقات الفعّالة بلا بريد اتصال صالح؛ لم يُرسل شيء.",
      EMAIL_ALREADY_SENT: "أُرسلت هذه الرسالة من قبل.",
      EMAIL_IN_PROGRESS: "الرسالة قيد الإرسال الآن.",
      EMAIL_OUTCOME_UNCERTAIN: "نتيجة الإرسال السابق غير معروفة. يراجعها مسؤول من LUD.",
      ACKNOWLEDGEMENT_REQUIRED: "يلزم تأكيد احتمال التكرار.",
      TOO_MANY_ATTEMPTS: "تم بلوغ الحد الأقصى لعدد المحاولات.",
      NO_ACTIVE_APPLICATIONS: "لا توجد تطبيقات فعّالة لهذا الفرع.",
      REQUEST_NOT_ELIGIBLE: "لا يمكن إرسال بريد لهذا الطلب.",
      PURPOSE_NOT_AVAILABLE: "هذه الرسالة غير متاحة لهذا الطلب.",
    },
  },
  branch: {
    section: "مسار تعديل الفرع",
    lifecycleLabel: "مرحلة الطلب",
    nativeStatus: "الحالة المسجلة",
    steps: ["مقدَّم", "تمت الموافقة", "إرسال للتطبيقات", "تأكيد التطبيقات", "التطبيق على المطعم"],
    changes: "التغيير المطلوب",
    hoursTitle: "أوقات العمل",
    day: "اليوم",
    current: "الحالي",
    requested: "المطلوب",
    closed: "مغلق",
    notRecorded: "غير مسجَّل",
    shiftSep: " / ",
    days: { sunday: "الأحد", monday: "الاثنين", tuesday: "الثلاثاء", wednesday: "الأربعاء", thursday: "الخميس", friday: "الجمعة", saturday: "السبت" },
    maintenance: { from: "بداية الإغلاق", to: "نهاية الإغلاق", reason: "السبب", currentStatus: "حالة الفرع الحالية" },
    originalFromReview: "سُجّلت القيم الحالية عند المراجعة لأن الطلب سابق لهذا المسار.",
    review: "المراجعة",
    reviewedBy: "قرار",
    reviewPending: "بانتظار قرار المطعم أو إدارة LUD.",
    noteLabel: "ملاحظة",
    approve: "موافقة",
    reject: "رفض",
    approveTitle: "الموافقة على الطلب",
    approveText: "الموافقة لا تغيّر بيانات المطعم. تسمح فقط بمراسلة التطبيقات الفعّالة، ولا تُطبَّق التغييرات إلا بعد تأكيد التطبيقات وإنهاء الطلب.",
    rejectTitle: "رفض الطلب",
    rejectText: "سيرى الكاشير سبب الرفض.",
    rejectReason: "سبب الرفض",
    impact: "أثر التغيير على التطبيقات",
    impactNone: "لا توجد تطبيقات فعّالة لهذا الفرع.",
    impactText: "ستُرسل رسالة منفصلة (عربي وإنجليزي) لكل تطبيق من التطبيقات الفعّالة:",
    summaryOf: (done, total) => `${done} من ${total} مؤكَّد`,
    applications: "التطبيقات المستهدفة",
    noTargets: "لم تُرسل أي رسالة بعد.",
    colApp: "التطبيق",
    colState: "الحالة",
    colSent: "وقت الإرسال",
    colAttempt: "آخر محاولة",
    colRecipients: "المستلمون",
    colConfirmation: "التأكيد",
    notConfirmed: "غير مؤكَّد",
    confirmedBy: (who) => `أكّده ${who}`,
    attemptsCount: (n) => `${n} محاولة`,
    state: { pending: "لم يُرسل", missingRecipient: "بلا بريد اتصال", sending: "جارٍ الإرسال", sent: "أُرسل (بانتظار التأكيد)", failed: "فشل الإرسال", uncertain: "نتيجة غير معروفة", confirmed: "مؤكَّد من التطبيق" },
    stateNote: {
      missingRecipient: "لا يوجد بريد اتصال مُعدّ لهذا التطبيق. أضِفه في الإعدادات ثم أرسل لهذا التطبيق فقط.",
      sent: "قبِل مزوّد البريد الرسالة. هذا ليس تأكيداً من التطبيق ولا إثباتاً للتسليم.",
      uncertain: "قد تكون الرسالة وصلت. لا تُعاد تلقائياً.",
      failed: "لم يقبل مزوّد البريد الرسالة.",
    },
    sendEmails: "معاينة وإرسال الرسائل للتطبيقات",
    sendMore: "إرسال للتطبيقات المتبقية",
    sendHint: "يُرسل لكل تطبيق فعّال رسالة منفصلة. لا يُعاد إرسال ما أُرسل سابقاً.",
    confirm: "تأكيد التطبيق",
    confirmTitle: (app) => `تأكيد تطبيق ${app}`,
    confirmText: "أكّد فقط بعد أن يردّ التطبيق أو يتحقق فريقك من تنفيذ التعديل عليه. لن يُغيَّر شيء في بيانات المطعم الآن.",
    confirmNote: "ملاحظة (اختياري)",
    confirmReference: "رقم مرجع التطبيق (اختياري)",
    confirmAck: "أؤكد أن هذا التطبيق نفّذ التعديل المطلوب",
    retrySend: "إعادة المحاولة",
    retryUncertain: "إعادة الإرسال (نتيجة غير معروفة)",
    uncertainTitle: (app) => `إعادة إرسال رسالة غير مؤكدة: ${app}`,
    uncertainWarn: "لا نعلم إن كانت المحاولة السابقة قد وصلت. قد يستلم التطبيق الرسالة مرتين.",
    uncertainLast: "آخر محاولة",
    uncertainAck: "أفهم أن الرسالة قد تكون وصلت من قبل، وأقبل احتمال إرسالها مرة ثانية",
    uncertainAdminOnly: "يعيد إرسال هذه الرسالة مسؤول من LUD فقط.",
    finalize: "إنهاء الطلب وتطبيق التغيير",
    finalizeTitle: "إنهاء الطلب",
    finalizeText: "سيُطبَّق التغيير على بيانات المطعم الآن مرة واحدة، ويصبح الطلب مكتملاً.",
    finalizeAck: "أؤكد تطبيق التغيير على بيانات المطعم",
    override: "إنهاء مع تجاوز التطبيقات غير المؤكدة",
    overrideTitle: "إنهاء مع تجاوز",
    overrideWarn: "بعض المنصات الخارجية لم تؤكّد بعد. سيُطبَّق التغيير على بيانات المطعم رغم ذلك، وتبقى هذه التطبيقات غير مؤكَّدة في السجل.",
    outstanding: "التطبيقات غير المؤكدة",
    overrideReason: "سبب التجاوز (إلزامي)",
    overrideAck: "أتحمل مسؤولية إنهاء الطلب قبل تأكيد التطبيقات المذكورة",
    completedWithOverride: "اكتمل بتجاوز",
    overrideInfo: "أُنهي الطلب رغم وجود تطبيقات غير مؤكدة:",
    overrideBy: "أنهاه",
    overrideReasonShown: "سبب التجاوز",
    applyError: "تعذّر تطبيق التغيير في المرة السابقة",
    cashierNote: "يتابع المطعم أو إدارة LUD هذا الطلب مع التطبيقات. ستظهر هنا مرحلته.",
    cashierRejected: "سبب الرفض",
    loadError: "تعذّر تحميل مسار الطلب.",
    errors: {
      ACCESS_DENIED: "ليست لديك صلاحية لهذا الإجراء.",
      REQUEST_NOT_PENDING: "تم البتّ في الطلب مسبقاً.",
      REASON_REQUIRED: "سبب الرفض مطلوب (5 أحرف على الأقل).",
      CONFIRMATION_REQUIRED: "يلزم التأكيد الصريح.",
      APPLICATION_NOT_FOUND: "هذا التطبيق ليس ضمن الطلب.",
      EMAIL_NOT_SENT: "لم تُرسل الرسالة لهذا التطبيق بنجاح بعد، فلا يمكن تأكيده.",
      ALREADY_CONFIRMED: "أُكِّد هذا التطبيق مسبقاً.",
      REQUEST_NOT_CONFIRMABLE: "الطلب ليس في مرحلة التأكيد.",
      UNCONFIRMED_APPLICATIONS: "بعض التطبيقات غير مؤكدة. أكّدها أولاً أو أنهِ الطلب مع تجاوز.",
      OVERRIDE_REASON_REQUIRED: "سبب التجاوز مطلوب (5 أحرف على الأقل).",
      ALREADY_COMPLETED: "الطلب مكتمل مسبقاً.",
      ALREADY_FINALIZING: "الطلب قيد الإنهاء الآن.",
      EMAIL_IN_PROGRESS: "هناك رسالة قيد الإرسال. انتظر انتهاءها.",
      APPLY_FAILED: "تعذّر تطبيق التغيير على بيانات المطعم. الطلب ما زال مفتوحاً ويمكن المحاولة مجدداً.",
      REQUEST_NOT_FINALIZABLE: "لا يمكن إنهاء هذا الطلب في حالته الحالية.",
      NOTHING_TO_SEND: "كل التطبيقات لديها رسالة بالفعل.",
      REQUEST_NOT_APPROVED: "يجب الموافقة على الطلب قبل مراسلة التطبيقات.",
    },
  },
  menuEmail: {
    status: { draft: "مسودة", failed: "فشل", sent: "تم الإرسال", canceled: "ملغى" },
    summary: (action, count, subject) => `${{ add: "إضافة", update: "تحديث", delete: "حذف" }[action] || action} · ${count === 1 ? "صنف واحد" : count === 2 ? "صنفان" : count >= 3 && count <= 10 ? `${count} أصناف` : `${count} صنفاً`}${subject ? ` — ${subject}` : ""}`,
    created: (date, name) => `أُنشئ ${date}${name ? ` بواسطة ${name}` : ""}`,
    preview: "معاينة",
    details: "التفاصيل",
    send: "إرسال",
    retry: "إعادة الإرسال",
    cancel: "إلغاء",
    detailsTitle: (reference) => `طلب إرسال أصناف إلى تطبيق — ${reference}`,
    loading: "جاري تحميل الطلب…",
    loadFailed: "تعذّر تحميل الطلب.",
    fields: { status: "الحالة", store: "المطعم", branch: "الفرع", app: "التطبيق", action: "الإجراء", items: "عدد الأصناف", createdAt: "تاريخ الإنشاء", createdBy: "المُرسِل", sentAt: "تاريخ الإرسال", reference: "المرجع", reason: "سبب الإلغاء", error: "الخطأ", attachment: "الملف المرفق" },
    actions: { add: "إضافة", update: "تحديث", delete: "حذف" },
    noBranch: "غير مرتبط بفرع",
    download: "تنزيل",
    downloadFailed: "تعذّر تنزيل الملف.",
    close: "إغلاق",
    cancelTitle: "إلغاء طلب الإرسال",
    cancelText: "لن يُرسل هذا البريد. اكتب سبب الإلغاء (إلزامي).",
    cancelReason: "سبب الإلغاء",
    cancelConfirm: "تأكيد الإلغاء",
    retryTitle: "إعادة إرسال البريد",
    retryText: "ستُعاد محاولة إرسال نفس الرسالة والملف المحفوظين. تأكد من التطبيق والمستلمين والمرفقات.",
    retryConfirm: "تأكيد إعادة الإرسال",
    retryUncertain: "نتيجة الإرسال السابق غير معروفة وقد تكون الرسالة وصلت. أؤكد قبول احتمال التكرار.",
    retryNoEmail: "لا توجد رسالة فاشلة لإعادة إرسالها.",
    purposeLabel: { ar: "إرسال أصناف القائمة إلى التطبيق", en: "Send menu items to the app" },
  },
  row: {
    actionStage: { storeReview: "قيد الاعتماد — المطعم", ludReview: "قيد الاعتماد — LUD", inProgress: "جاري العمل", activated: "مفعّل", completed: "مكتمل", rejected: "مرفوض", canceled: "ملغى", deleted: "محذوف" },
    uploadFile: "رفع الملف",
    uploadContract: "رفع العقد",
    downloadContract: "تنزيل العقد",
    downloadSigned: "تنزيل العقد الموقّع",
    downloadStatement: "تنزيل كشف الحساب",
    downloadTaxInvoice: "تنزيل الفاتورة الضريبية",
    downloadFile: (name) => `تنزيل ${name || "الملف"}`,
    files: "الملفات",
    underReview: "قيد المراجعة",
    waitingStore: "بانتظار إجراء المطعم",
    uploadSigned: "رفع العقد الموقّع",
    approve: "موافقة",
    reject: "رفض",
    cancel: "إلغاء",
    applications: "التطبيقات",
    hours: "الأوقات المطلوبة",
    hideApplications: "إخفاء التطبيقات",
    confirmApproval: "تأكيد الموافقة",
    confirmRejection: "تأكيد الرفض",
    confirmFinalization: "تأكيد الإنهاء",
    confirmCancellation: "تأكيد الإلغاء",
    confirmUpload: "تأكيد الرفع",
    confirmSignedUpload: "تأكيد رفع العقد الموقّع",
    approveTitle: "الموافقة على الطلب",
    approveText: "سيُسجَّل قرار الموافقة وينتقل الطلب إلى المكتملة.",
    rejectTitle: "رفض الطلب",
    rejectText: "اكتب سبب الرفض. سيظهر السبب في الطلب.",
    rejectReason: "سبب الرفض",
    cancelTitle: "إلغاء الطلب",
    cancelText: "سيُلغى هذا الطلب وينتقل إلى المكتملة.",
    cancelNote: "ملاحظة (اختياري)",
    back: "رجوع",
    close: "إغلاق",
    chooseFile: "اختر ملفاً",
    noFile: "لم يُختر ملف بعد.",
    upload: "رفع",
    uploading: "جاري الرفع…",
    confirmUploadText: (name) => `سيُرفع الملف «${name}» إلى هذا الطلب. هل تريد المتابعة؟`,
    fileEmpty: "الملف فارغ.",
    fileType: "نوع الملف غير مقبول لهذا الطلب.",
    fileSize: "حجم الملف أكبر من 10 ميغابايت.",
    uploadFailed: "تعذّر رفع الملف.",
    stage: {
      awaitingLud: "بانتظار رفع العقد من LUD",
      awaitingSignature: "بانتظار توقيع المطعم",
      awaitingReview: "العقد الموقّع بانتظار مراجعة LUD",
    },
    closure: (from, to) => `الإغلاق: ${from}${to && to !== from ? ` – ${to}` : ""}`,
    final: { completed: "مكتمل", approved: "مكتمل", rejected: "مرفوض", canceled: "ملغى", sent: "تم الإرسال" },
    withOverride: "بتجاوز",
    reasonLabel: "السبب",
  },
  readOnlyNote: "هذه الصفحة للعرض؛ تنفَّذ الإجراءات عبر مسار كل طلب الأصلي.",
};

const en = {
  sections: { inProgress: "In Progress", completed: "Completed" },
  emptySection: { inProgress: "No requests in progress.", completed: "No completed requests." },
  countLabel: (n) => `${n} request${n === 1 ? "" : "s"}`,
  quickActions: "Quick actions",
  expand: { expand: "Click to show the full text", collapse: "Click to collapse the text" },
  title: "Requests",
  details: "Details",
  openDetails: "View request details",
  loading: "Loading requests…",
  errorTitle: "Requests could not be loaded",
  retry: "Try again",
  forbidden: "You do not have access to this restaurant.",
  network: "The server could not be reached.",
  pagination: { nav: "Pagination", previous: "Previous", next: "Next", limit: "The maximum browsing depth was reached; use filters to narrow the results.", summary: (page, pages, total) => `Page ${page}${pages ? ` of ${pages}` : ""}${total !== null && total !== undefined ? ` · ${total} requests` : ""}` },
  noValue: "—",
  hidden: "hidden",
  modal: {
    close: "Close",
    moreInfo: "More information",
    info: "Request information",
    scope: "Scope",
    status: "Status",
    original: "Original status",
    reference: "Reference",
    type: "Type",
    category: "Category",
    store: "Restaurant",
    branch: "Branch",
    app: "Application",
    creator: "Created by",
    created: "Created",
    updated: "Last update",
    summary: "Summary",
    changes: "Requested changes",
    current: "Current",
    requested: "Requested",
    approvals: "Approvals",
    history: "History",
    historyEmpty: "This request has no history.",
    attachments: "Attachments",
    actions: "Actions",
    noActions: "No actions are available to you on this request.",
    openOriginal: "Open the original page",
    loadError: "The request details could not be loaded.",
    notFound: "The request does not exist or you do not have access to it.",
    onBehalf: "Approved on behalf of the client",
    clientApproval: "Client approval",
    managerApproval: "LUD manager approval",
    waiting: "Waiting for a decision",
    approved: "Approved",
    rejected: "Rejected",
    reason: "Reason",
    note: "Note",
  },
  action: {
    approveClient: "Approve (client)",
    rejectClient: "Reject",
    approveManager: "Approve (manager)",
    rejectManager: "Reject",
    onBehalf: "Approve on behalf of client",
    activate: "Activate",
    completed: "Mark completed",
    rejected: "Reject",
    inprogress: "Mark in progress",
    cancelCampaign: "Cancel campaign",
    deleteRequest: "Delete request",
    edit: "Edit in Operations",
    approve: "Approve",
    reject: "Reject",
    cancel: "Cancel request",
    upload: "Upload file",
    send: "Send",
    retry: "Retry sending",
    complete: "Mark completed",
    editApp: "Edit in Applications",
    chooseFile: "Choose a file",
    fileKind: "File type",
    confirm: "Confirm",
    more: "More actions",
    cancelDialog: "Go back",
    reasonLabel: "Reason",
    reasonRequired: "A reason is required (at least 3 characters).",
    optionalNote: "Note (optional)",
    working: "Working…",
    failed: "The action could not be completed.",
    done: "Action completed.",
    confirmOnBehalf: "I confirm the client has agreed to this request",
    onBehalfNote: "Your approval is recorded under your own name, role and reason. The independent LUD manager approval is still required afterwards, from a different person.",
    statusTitle: (label) => `Confirm: ${label}`,
    confirmText: "Are you sure? This is carried out immediately through the request's original workflow.",
    uploadCompletes: "Uploading this file completes the request.",
    sendNote: "This e-mail will be sent to the application:",
    subject: "Subject",
    to: "To",
    cc: "Cc",
    approveDashboard: "The requested changes are applied to the restaurant's data when approved.",
  },
  fields: {
    description: "Description",
    target: "Target",
    campaignName: "Campaign name",
    campaignDetails: "Campaign details",
    startDate: "Start date",
    endDate: "End date",
    origin: "Origin",
    source: "Source",
    reviewedBy: "Reviewed by",
    reviewedAt: "Reviewed at",
    reviewNote: "Review note",
    appliedAt: "Applied at",
    applyError: "Last execution error",
    reason: "Reason",
    version: "Version",
    scope: "Scope",
    account: "Proposed account",
    manager: "Proposed manager",
    branches: "Branches",
    passwordProvided: "Password: provided (not shown)",
    rejection: "Rejection reason",
    language: "Language",
    sentAt: "Sent at",
    completedAt: "Completed at",
    cancelledAt: "Canceled at",
    lastError: "Last error",
    attempts: "Send attempts",
    possiblyDelivered: "The e-mail may have been delivered (sending was interrupted)",
    day: { sunday: "Sunday", monday: "Monday", tuesday: "Tuesday", wednesday: "Wednesday", thursday: "Thursday", friday: "Friday", saturday: "Saturday" },
    closed: "Closed",
    willChange: "Will be changed",
  },
  events: {
    created: "Request created",
    alreadyActive: "Entered as an active campaign",
    approved: "Approved",
    rejected: "Rejected",
    status: "Status changed",
    edited: "Request edited",
    cancellationRequested: "Campaign canceled",
    deleted: "Request deleted",
    approvedOnBehalfOfClient: "Approved on behalf of the client",
    cancelled: "Request canceled",
    approval_failed: "Applying the approval failed",
    send: "Sending started",
    accepted: "Accepted by the mail provider",
    failed: "Sending failed",
    recovered: "Recovered after an interruption",
    cancel: "Request canceled",
    complete: "Request completed",
  },
  email: {
    section: "E-mail",
    history: "Sent e-mails",
    empty: "No e-mails are linked to this request.",
    email: "E-mail",
    status: { sending: "Sending", sent: "Accepted by mail provider", failed: "Failed", uncertain: "Outcome unknown", none: "Not sent" },
    acceptedNote: "The mail provider accepted this message. That does not mean it was delivered or read.",
    uncertainNote: "It is not known whether this message went out. It is never re-sent automatically; a LUD administrator reviews it.",
    attempts: "Send attempts",
    attempt: "Attempt",
    result: { accepted: "accepted", failed: "failed", uncertain: "unknown", sending: "in progress" },
    errorKind: { configuration: "configuration", validation: "invalid data", provider: "mail provider", network: "network", unknown: "unknown" },
    viewMessage: "View message",
    hideMessage: "Hide message",
    retry: "Retry sending",
    to: "To",
    cc: "Cc",
    subject: "Subject",
    attachments: "Attachments",
    body: "Message body",
    recipients: "Applications receiving this e-mail",
    missingTitle: "Cannot send: active applications without a valid contact e-mail",
    missing: { RECIPIENT_NOT_CONFIGURED: "no contact e-mail is configured", RECIPIENT_INVALID: "the configured contact e-mail is invalid", UNKNOWN_APPLICATION: "unknown application" },
    warnings: { STORE_EMAIL_INVALID: "The restaurant's e-mail is invalid; it will not be copied." },
    send: "Preview & send",
    dialogTitle: (label) => `Preview & send: ${label}`,
    previewing: "Preparing the message…",
    previewError: "The message could not be prepared.",
    reviewNote: "Review the messages below. Nothing is sent until you confirm.",
    confirm: (count) => `I reviewed the messages and confirm sending them to ${count} application${count === 1 ? "" : "s"}`,
    sendNow: "Send",
    sendSelected: (count) => `Send (${count})`,
    selectTitle: "Choose the applications to e-mail now",
    selectAll: "Select all",
    deselectAll: "Deselect all",
    selectOne: "Select at least one application.",
    selectedCount: (count, total) => `Selected: ${count} of ${total}. Unselected applications stay pending and can be sent later.`,
    confirmSelected: (names) => `I reviewed the messages and confirm sending them to: ${names.join(", ")}`,
    alreadySent: "Already sent - will not be sent again",
    missingPartial: "Not included now: applications without a valid contact e-mail",
    willSend: "Will be sent",
    partialNote: "Applications without a contact e-mail are skipped for now; they stay listed as missing and can be sent later.",
    sending: "Sending…",
    sentTitle: "Sending result",
    allSent: "The mail provider accepted every message.",
    someNotSent: "Some messages were not accepted. You can retry only the failed ones.",
    draftChanged: "The message changed since the preview. Review the new version and confirm again.",
    close: "Close",
    errors: {
      EMAIL_ACCESS_DENIED: "You are not allowed to send this e-mail.",
      RECIPIENTS_MISSING: "Some active applications have no valid contact e-mail; nothing was sent.",
      EMAIL_ALREADY_SENT: "This e-mail was already sent.",
      EMAIL_IN_PROGRESS: "This e-mail is being sent right now.",
      EMAIL_OUTCOME_UNCERTAIN: "The outcome of the previous send is unknown. A LUD administrator must review it.",
      ACKNOWLEDGEMENT_REQUIRED: "Confirmation of a possible duplicate is required.",
      TOO_MANY_ATTEMPTS: "The maximum number of attempts was reached.",
      NO_ACTIVE_APPLICATIONS: "This branch has no active application to notify.",
      REQUEST_NOT_ELIGIBLE: "This request cannot be e-mailed.",
      PURPOSE_NOT_AVAILABLE: "This e-mail is not available for this request.",
    },
  },
  branch: {
    section: "Branch change workflow",
    lifecycleLabel: "Stage",
    nativeStatus: "Recorded status",
    steps: ["Submitted", "Approved", "Notify applications", "Applications confirm", "Apply to restaurant"],
    changes: "Requested change",
    hoursTitle: "Working hours",
    day: "Day",
    current: "Current",
    requested: "Requested",
    closed: "Closed",
    notRecorded: "Not recorded",
    shiftSep: " / ",
    days: { sunday: "Sunday", monday: "Monday", tuesday: "Tuesday", wednesday: "Wednesday", thursday: "Thursday", friday: "Friday", saturday: "Saturday" },
    maintenance: { from: "Closure starts", to: "Closure ends", reason: "Reason", currentStatus: "Current branch status" },
    originalFromReview: "The current values were recorded at review because this request predates the workflow.",
    review: "Review",
    reviewedBy: "Decision",
    reviewPending: "Waiting for a decision from the restaurant or LUD.",
    noteLabel: "Note",
    approve: "Approve",
    reject: "Reject",
    approveTitle: "Approve this request",
    approveText: "Approving does not change the restaurant's data. It only allows the active applications to be notified; the change is applied after the applications confirm and the request is finalized.",
    rejectTitle: "Reject this request",
    rejectText: "The cashier will see the reason.",
    rejectReason: "Rejection reason",
    impact: "Impact on applications",
    impactNone: "This branch has no active application.",
    impactText: "A separate message (Arabic and English) will go to each active application:",
    summaryOf: (done, total) => `${done} of ${total} confirmed`,
    applications: "Targeted applications",
    noTargets: "No e-mail has been sent yet.",
    colApp: "Application",
    colState: "Status",
    colSent: "Sent",
    colAttempt: "Last attempt",
    colRecipients: "Recipients",
    colConfirmation: "Confirmation",
    notConfirmed: "Not confirmed",
    confirmedBy: (who) => `Confirmed by ${who}`,
    attemptsCount: (n) => `${n} attempt${n === 1 ? "" : "s"}`,
    state: { pending: "Not sent", missingRecipient: "No contact e-mail", sending: "Sending", sent: "Sent (awaiting confirmation)", failed: "Send failed", uncertain: "Outcome unknown", confirmed: "Confirmed by application" },
    stateNote: {
      missingRecipient: "No contact e-mail is configured for this application. Configure it, then send to this application only.",
      sent: "The mail provider accepted the message. That is neither a confirmation from the application nor proof of delivery.",
      uncertain: "The message may have been received. It is never re-sent automatically.",
      failed: "The mail provider did not accept the message.",
    },
    sendEmails: "Preview & send e-mails to applications",
    sendMore: "Send to remaining applications",
    sendHint: "One separate e-mail per active application. Anything already sent is not sent again.",
    confirm: "Confirm application",
    confirmTitle: (app) => `Confirm ${app}`,
    confirmText: "Confirm only after the application replied or your team verified the change on it. Nothing changes in the restaurant's data now.",
    confirmNote: "Note (optional)",
    confirmReference: "Application reference number (optional)",
    confirmAck: "I confirm that this application implemented the requested change",
    retrySend: "Retry",
    retryUncertain: "Resend (outcome unknown)",
    uncertainTitle: (app) => `Resend an unconfirmed e-mail: ${app}`,
    uncertainWarn: "We do not know whether the previous attempt arrived. The application may receive the message twice.",
    uncertainLast: "Last attempt",
    uncertainAck: "I understand the message may already have been received and I accept a possible duplicate",
    uncertainAdminOnly: "Only a LUD administrator can resend this e-mail.",
    finalize: "Finalize & apply change",
    finalizeTitle: "Finalize this request",
    finalizeText: "The change will now be applied to the restaurant's data, once, and the request becomes completed.",
    finalizeAck: "I confirm applying the change to the restaurant's data",
    override: "Finalize despite unconfirmed applications",
    overrideTitle: "Finalize with override",
    overrideWarn: "Some external platforms have not confirmed yet. The change will still be applied to the restaurant's data, and these applications stay unconfirmed in the record.",
    outstanding: "Unconfirmed applications",
    overrideReason: "Override reason (required)",
    overrideAck: "I take responsibility for finalizing before the applications above confirmed",
    completedWithOverride: "Completed with override",
    overrideInfo: "The request was finalized while some applications were not confirmed:",
    overrideBy: "Finalized by",
    overrideReasonShown: "Override reason",
    applyError: "The previous attempt to apply the change failed",
    cashierNote: "The restaurant or LUD follows this request up with the applications. Its stage is shown here.",
    cashierRejected: "Rejection reason",
    loadError: "The workflow could not be loaded.",
    errors: {
      ACCESS_DENIED: "You are not allowed to do this.",
      REQUEST_NOT_PENDING: "This request was already decided.",
      REASON_REQUIRED: "A rejection reason (at least 5 characters) is required.",
      CONFIRMATION_REQUIRED: "Explicit confirmation is required.",
      APPLICATION_NOT_FOUND: "This application is not part of the request.",
      EMAIL_NOT_SENT: "The e-mail to this application has not been sent successfully yet, so it cannot be confirmed.",
      ALREADY_CONFIRMED: "This application was already confirmed.",
      REQUEST_NOT_CONFIRMABLE: "The request is not in the confirmation stage.",
      UNCONFIRMED_APPLICATIONS: "Some applications are not confirmed. Confirm them first or finalize with an override.",
      OVERRIDE_REASON_REQUIRED: "An override reason (at least 5 characters) is required.",
      ALREADY_COMPLETED: "The request is already completed.",
      ALREADY_FINALIZING: "The request is being finalized right now.",
      EMAIL_IN_PROGRESS: "An e-mail is being sent. Wait for it to finish.",
      APPLY_FAILED: "The change could not be applied to the restaurant's data. The request is still open; you can try again.",
      REQUEST_NOT_FINALIZABLE: "This request cannot be finalized in its current state.",
      NOTHING_TO_SEND: "Every application already has an e-mail.",
      REQUEST_NOT_APPROVED: "The request must be approved before the applications are notified.",
    },
  },
  menuEmail: {
    status: { draft: "Draft", failed: "Failed", sent: "Sent", canceled: "Cancelled" },
    summary: (action, count, subject) => `${{ add: "Add", update: "Update", delete: "Delete" }[action] || action} · ${count} ${count === 1 ? "item" : "items"}${subject ? ` — ${subject}` : ""}`,
    created: (date, name) => `Created ${date}${name ? ` by ${name}` : ""}`,
    preview: "Preview",
    details: "Details",
    send: "Send",
    retry: "Retry",
    cancel: "Cancel",
    detailsTitle: (reference) => `Menu items email request — ${reference}`,
    loading: "Loading the request…",
    loadFailed: "Could not load the request.",
    fields: { status: "Status", store: "Restaurant", branch: "Branch", app: "App", action: "Action", items: "Items", createdAt: "Created", createdBy: "Sender", sentAt: "Sent", reference: "Reference", reason: "Cancellation reason", error: "Error", attachment: "Attached file" },
    actions: { add: "Add", update: "Update", delete: "Delete" },
    noBranch: "Not tied to a branch",
    download: "Download",
    downloadFailed: "Could not download the file.",
    close: "Close",
    cancelTitle: "Cancel the email request",
    cancelText: "This email will not be sent. Write the reason for cancelling (required).",
    cancelReason: "Cancellation reason",
    cancelConfirm: "Confirm cancellation",
    retryTitle: "Retry sending the email",
    retryText: "The same saved message and file will be sent again. Check the app, the recipients and the attachments.",
    retryConfirm: "Confirm and retry",
    retryUncertain: "The outcome of the previous send is unknown and it may have been delivered. I accept a possible duplicate.",
    retryNoEmail: "There is no failed email to retry.",
    purposeLabel: { ar: "إرسال أصناف القائمة إلى التطبيق", en: "Send menu items to the app" },
  },
  row: {
    actionStage: { storeReview: "Pending — Store Approval", ludReview: "Pending — LUD Approval", inProgress: "In Progress", activated: "Activated", completed: "Completed", rejected: "Rejected", canceled: "Canceled", deleted: "Deleted" },
    uploadFile: "Upload File",
    uploadContract: "Upload Contract",
    downloadContract: "Download Contract",
    downloadSigned: "Download Signed Contract",
    downloadStatement: "Download Statement",
    downloadTaxInvoice: "Download Tax Invoice",
    downloadFile: (name) => `Download ${name || "file"}`,
    files: "Files",
    underReview: "Under Review",
    waitingStore: "Waiting for Store Action",
    uploadSigned: "Upload Signed Contract",
    approve: "Approve",
    reject: "Reject",
    cancel: "Cancel",
    applications: "Applications",
    hours: "Requested hours",
    hideApplications: "Hide applications",
    confirmApproval: "Confirm Approval",
    confirmRejection: "Confirm Rejection",
    confirmFinalization: "Confirm Finalization",
    confirmCancellation: "Confirm Cancellation",
    confirmUpload: "Confirm Upload",
    confirmSignedUpload: "Confirm Signed Contract Upload",
    approveTitle: "Approve this request",
    approveText: "The approval is recorded and the request moves to Completed.",
    rejectTitle: "Reject this request",
    rejectText: "Write the reason for the rejection. It stays on the request.",
    rejectReason: "Rejection reason",
    cancelTitle: "Cancel this request",
    cancelText: "This request will be canceled and moved to Completed.",
    cancelNote: "Note (optional)",
    back: "Back",
    close: "Close",
    chooseFile: "Choose a file",
    noFile: "No file selected yet.",
    upload: "Upload",
    uploading: "Uploading…",
    confirmUploadText: (name) => `The file "${name}" will be uploaded to this request. Continue?`,
    fileEmpty: "The file is empty.",
    fileType: "This file type is not accepted for this request.",
    fileSize: "The file is larger than 10 MB.",
    uploadFailed: "The file could not be uploaded.",
    stage: {
      awaitingLud: "Waiting for LUD to upload the contract",
      awaitingSignature: "Awaiting restaurant signature",
      awaitingReview: "Signed contract awaiting LUD review",
    },
    closure: (from, to) => `Closure: ${from}${to && to !== from ? ` – ${to}` : ""}`,
    final: { completed: "Completed", approved: "Completed", rejected: "Rejected", canceled: "Canceled", sent: "Sent" },
    withOverride: "with override",
    reasonLabel: "Reason",
  },
  readOnlyNote: "This page is for viewing; actions run through each request's own workflow.",
};

export const requestsText = (lang) => (lang === "ar" ? ar : en);
export const pick = (label, lang) => (label ? label[lang === "ar" ? "ar" : "en"] || label.en || label.ar || "" : "");
